import Backbone from "backbone";
import Handlebars from "handlebars";
import _ from "underscore";

import {loadLiveEditorI18n} from "@khan/component-live-editor";
import {importFromExternalScript} from "@khan/util-external-script";
import {LocalStore} from "@khan/util-local-store";

import $ from "#jquery/jquery-with-scratchpad-plugins.js";

import ScratchpadUIChallenge from "./scratchpad-ui-challenge.ts";
import ScratchpadUIPlayback from "./scratchpad-ui-playback.ts";
import ScratchpadUIProject from "./scratchpad-ui-project.ts";
import ScratchpadUIProgress from "./scratchpad-ui-user-progress.ts";
import {ScratchpadUI} from "./scratchpad-ui.tsx";

export const ScratchpadUIStart = async function (options: any = {}) {
    // Expose globals for LiveEditor
    // @ts-expect-error - TS2339 - Property 'i18n' does not exist on type 'Window & typeof globalThis'.
    window.i18n = loadLiveEditorI18n();
    window.Handlebars = Handlebars;
    window.Backbone = Backbone;
    // @ts-expect-error - TS2740 - Type 'UnderscoreStatic' is missing the following properties from type 'LoDashStatic': concat, differenceBy, differenceWith, dropRight, and 187 more.
    window._ = _;
    // @ts-expect-error - TS2339 - Property '$' does not exist on type 'Window & typeof globalThis'.
    window.$ = $;
    // @ts-expect-error - TS2339 - Property 'jQuery' does not exist on type 'Window & typeof globalThis'.
    window.jQuery = $;
    Backbone.$ = $;

    // Register editor types (must come at the end to ensure that i18n.js exists)
    // NOTE(jeresig): It's possible that these files may not need to be loaded
    // serially like this, but that is a future optimization that can be
    // tested and explored.
    await import("live-editor/build/js/live-editor.shared");
    await import("live-editor/build/js/live-editor.audio");
    const LiveEditorUI = await import(
        "live-editor/build/js/live-editor.ui"
    ).then((m) => m.default);
    const Structured = await import(
        "live-editor/build/external/structuredjs/structured"
    ).then((m) => m.default);
    // We load this as static JS file to avoid having to build it using
    // Webpack, as it's quite large (~1.24MB in total). As a result we're not
    // going to be able to update the fils in a traditional manner. We'll have
    // to either rename it or clear the cache in Fastly if we ever change it.
    // Also this file will never be able to have i18n strings inside it.
    await importFromExternalScript(
        // We explicitly want to load this from the CDN always.
        // eslint-disable-next-line static-service/dont-hardcode-cdn
        "https://cdn.kastatic.org/third_party/javascript-khansrc/live-editor/build/js/live-editor.editor_ace_deps.js",
    );
    await import("live-editor/build/js/live-editor.tooltips");
    await import("live-editor/build/js/live-editor.editor_ace");
    await import("live-editor/build/js/live-editor.editor_textarea");

    const LiveEditor = LiveEditorUI.LiveEditor;

    LiveEditor.prototype.render = function () {
        // NOTE(jeresig): We render our own version of the live editor in
        // Scratchpad.jsx
    };
    ScratchpadUI.LiveEditor = LiveEditor;
    ScratchpadUI.Structured = Structured;

    // Register event listeners on ScratchpadUI.
    //
    // TODO(jlfwong): These files also have the side effect of mutating the
    // global ScratchpadUI object.
    ScratchpadUIPlayback.bindEvents(ScratchpadUI);
    ScratchpadUIProject.bindEvents(ScratchpadUI, options);
    ScratchpadUIChallenge.bindEvents(ScratchpadUI);
    ScratchpadUIProgress.bindEvents(ScratchpadUI);

    $(ScratchpadUI).on({
        started: function () {
            ScratchpadUI.registerCodeChange(() => {
                ScratchpadUI.loadDocumentationScratchpads();
            });
            // Check if the user clicked on a position that puts the cursor
            // at the end of the line.  If so, add a new line if one doesn't
            // already exist.  Some younger users try to click to go to the
            // next line.  Don't do this neither when recording nor playing.
            const editor = ScratchpadUI.liveEditor.editor;
            editor.on("click", function () {
                const isTalkie = ScratchpadUI.scratchpad.isTalkie();
                if (
                    (isTalkie && !ScratchpadUI.liveEditor.record.playing) ||
                    !isTalkie
                ) {
                    editor.insertNewlineIfCursorAtEnd();
                }
            });

            // Fold relevant rows
            const folds = ScratchpadUI.scratchpad.getFolds();
            ScratchpadUI.liveEditor.editor.setFolds(folds);

            ScratchpadUI.initResizing();
        },
    });

    $(ScratchpadUI).on("remove", function () {
        if (!ScratchpadUI.liveEditor) {
            return;
        }
        ScratchpadUI.liveEditor.remove();

        const scratchpad = ScratchpadUI.scratchpad;
        const code = ScratchpadUI.liveEditor.editor.text();
        const revision = scratchpad.currentRevision();

        if (scratchpad.isNew()) {
            // Extract current editor text
            revision.set("code", code);

            // Save the cached results to localStorage for later retrieval
            LocalStore.set(ScratchpadUI.localStorage.SCRATCHPADS, {
                cursor: ScratchpadUI.liveEditor.editor.getCursor(),
                scratchpad: ScratchpadUI.scratchpad,
            });
        }
    });
};
